"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnMyUsd = exports.EnMyMyr = void 0;
class EnMyMyr {
    constructor() {
        this.locale = "en-my";
        this.dateFormat = {
            short: "d/M/yyyy",
            medium: "MMMM dd, yyyy",
            long: "dddd, d MMMM, yyyy",
        };
        this.currencyFormat = {
            code: "MYR",
            symbol: "RM",
            decimalSeparator: ".",
            groupSeparator: ",",
            positivePattern: "C n",
            negativePattern: "C -n"
        };
    }
}
exports.EnMyMyr = EnMyMyr;
class EnMyUsd {
    constructor() {
        this.locale = "en-my";
        this.dateFormat = {
            short: "d/M/yyyy",
            medium: "MMMM dd, yyyy",
            long: "dddd, d MMMM, yyyy",
        };
        this.currencyFormat = {
            code: "USD",
            symbol: "US$",
            decimalSeparator: ".",
            groupSeparator: ",",
            positivePattern: "C n",
            negativePattern: "C -n"
        };
    }
}
exports.EnMyUsd = EnMyUsd;
